// Types
import type { Action } from "./types";

/**
 * @desc fetch the employees of a company so a super admin can pick who the
 * manual contribution invoice is raised for
 * @param {*} data business guid
 * @return {*}  {Action}
 */
export const fetchManualInvoiceEmployees = (data: any): Action => ({
  type: "FETCH_MANUAL_INVOICE_EMPLOYEES",
  data,
});

/**
 * @param {*} data
 * @return {*}  {Action}
 */
export const editManualInvoiceEmployees = (data: any): Action => ({
  type: "EDIT_MANUAL_INVOICE_EMPLOYEES",
  data,
});

/**
 * @desc create a manual contribution invoice for a prepay company
 * @param {*} data { businessGuid, contributions, sendEmail }
 * @return {*}  {Action}
 */
export const createManualInvoice = (data: any): Action => ({
  type: "CREATE_MANUAL_INVOICE",
  data,
});

/**
 * @param {*} data the created invoice returned by the API
 * @return {*}  {Action}
 */
export const editManualInvoiceCreated = (data: any): Action => ({
  type: "EDIT_MANUAL_INVOICE_CREATED",
  data,
});

/**
 * @desc per field validation errors returned by the API, keyed by field path
 * @param {*} data
 * @return {*}  {Action}
 */
export const editManualInvoiceFieldErrors = (data: any): Action => ({
  type: "EDIT_MANUAL_INVOICE_FIELD_ERRORS",
  data,
});

/**
 * @return {*}  {Action}
 */
export const clearManualInvoice = (): Action => ({
  type: "CLEAR_MANUAL_INVOICE",
});

/**
 * @desc fetch which invoice types a super admin may raise by hand for a company
 * @param {*} data business guid
 * @return {*}  {Action}
 */
export const fetchManualInvoiceOptions = (data: any): Action => ({
  type: "FETCH_MANUAL_INVOICE_OPTIONS",
  data,
});

/**
 * @param {*} data
 * @return {*}  {Action}
 */
export const editManualInvoiceOptions = (data: any): Action => ({
  type: "EDIT_MANUAL_INVOICE_OPTIONS",
  data,
});

/**
 * @desc raise a Float invoice for a postpay company
 * @param {*} data { businessGuid, amount, sendEmail }
 * @return {*}  {Action}
 */
export const createManualFloatInvoice = (data: any): Action => ({
  type: "CREATE_MANUAL_FLOAT_INVOICE",
  data,
});

/**
 * @desc ask the invoice engine to run a PEPM invoice for a postpay company
 * @param {*} data { businessGuid, runDate, sendEmail }
 * @return {*}  {Action}
 */
export const createManualPepmInvoice = (data: any): Action => ({
  type: "CREATE_MANUAL_PEPM_INVOICE",
  data,
});
